import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import CTASection from './components/CTASection';
import HomeSchema from './components/HomeSchema';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <>
      <HomeSchema />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedArticles />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}